import { createReducer, on } from '@ngrx/store';

export const initialState = null;
import { showAbandonCartInlineLoader, hideAbandonCartInlineLoader } from '../_actions/inline-loader.actions';


const _inlineLoaderAbandonCartReducer = createReducer(initialState,
    on(showAbandonCartInlineLoader, (state) => {
      return true;
    }),
    on(hideAbandonCartInlineLoader, (state) => {
      return false;
    })
); 


export function inlineLoaderAbandonCartReducer(state, action) {
    return _inlineLoaderAbandonCartReducer(state, action);
}
